/**
 * Sensor Registry
 * 
 * This file registers all sensor types and their schemas.
 * When adding a new sensor, import its schema here and add it to the registry.
 */

import { CalibrationDisplaySchema } from "./types";
import { displacementSensorSchema } from "./displacement";
import { PiezometerSchema } from "./piezometer";
import { AccelerometerSchema } from "./accelerometer";
import { TiltmeterSchema } from "./tiltmeter";
import { StrainGaugeSchema } from "./strain_gauge";

// Registry of all sensor schemas
export const sensorSchemaRegistry: Record<string, CalibrationDisplaySchema> = {
  displacement: displacementSensorSchema,
  piezometer: PiezometerSchema,
  accelerometer: AccelerometerSchema,
  tiltmeter: TiltmeterSchema,
  resistive_strain_gauge: StrainGaugeSchema,
};

/**
 * Get all registered sensor types
 */
export function getRegisteredSensorTypes(): string[] {
  return Object.keys(sensorSchemaRegistry);
}

/**
 * Check if a sensor type is registered
 */
export function isSensorTypeRegistered(sensorType: string): boolean {
  return sensorType.toLowerCase() in sensorSchemaRegistry;
}

